//***************** Function Slider-Arrow Button Start *******************//
const initializeSliderArrowNavigation = (container_name, prev, next) => {
    const container = document.querySelector(container_name);
    const prevArrow = document.getElementById(prev);
    const nextArrow = document.getElementById(next);
    
    if (!container || !prevArrow || !nextArrow) return;
    
    // Calculate scroll amount based on screen size and product width
    const getScrollAmount = () => {
      const isMobile = window.innerWidth <= 767;
      const products = container.querySelectorAll('.block.product');
      
      if (products.length < 2){
        console.log("Product length is zero return default size 300")
        return 300;
      }
      
      // Get actual dimensions from DOM
      const firstProduct = products[0];
      const secondProduct = products[1];
      
      // Calculate product width including margins/padding
      const firstProductRect = firstProduct.getBoundingClientRect();
      const secondProductRect = secondProduct.getBoundingClientRect();
      
      // Calculate actual gap between products
      const actualGap = secondProductRect.left - firstProductRect.right;
      
      // Get product width (including any padding/margin)
      const productWidth = firstProductRect.width;
      
      // Calculate one product scroll distance (product width + gap)
      const singleProductScroll = productWidth + actualGap;
      
      // console.log('Product width:', productWidth);
      // console.log('Actual gap:', actualGap);
      // console.log('Single product scroll:', singleProductScroll);
      
      if (isMobile) {
        // On mobile: scroll by exactly 2 products
        return singleProductScroll * 2;
      } else {
        // On desktop: scroll by exactly 3 products
        return singleProductScroll * 3;
      }
      
    };
    
    // Update arrow states based on scroll position
    const updateArrowStates = () => {
      // const isAtStart = container.scrollLeft <= 0;
      // const isAtEnd = container.scrollLeft >= container.scrollWidth - container.clientWidth;
      const isAtStart = container.scrollLeft <= 5; // Small tolerance
      const isAtEnd = container.scrollLeft >= container.scrollWidth - container.clientWidth - 5;
      
      prevArrow.disabled = isAtStart;
      nextArrow.disabled = isAtEnd;
    };
    
    // Left arrow click
    prevArrow.addEventListener('click', () => {
      const scrollAmount = getScrollAmount();
      // console.log("Previous scroll amount: ", scrollAmount)
      container.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    });
    
    // Right arrow click
    nextArrow.addEventListener('click', () => {
      const scrollAmount = getScrollAmount();
      // console.log("Next scroll amount: ", scrollAmount)
      container.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    });
    
    // Update arrow states on scroll
    container.addEventListener('scroll', updateArrowStates);
    
    // Initial state update
    updateArrowStates();
    
    // Update states after window resize
    window.addEventListener('resize', () => {
      setTimeout(updateArrowStates, 100);
    });
};

//***************** Flickity Slider-Arrow Button end *******************//

//***************** Update Variant IDs on AddToCart Buttons Start *******************//
// Setting variant IDs on all default add-to-cart buttons when click an item variant
// product-block.liquid default add-to-cart buttons
// featured-product.liquid default add-to-cart buttons
(function () {
  $(document).on('change', '.original-selector', function () {
    var variantId = $(this).val();
    console.log("setVariantId:\n")
    console.log(variantId)
    var $container = $(this).closest('.product-form, .product-container, .block.product');

    if ($container.length) {
      // Update all add-to-cart buttons
      $container.find('.add-to-cart').each(function () {
        $(this).attr('data-variant-id', variantId);
      });

      // Update wishlist button if present
      var $swymBtn = $container.find('.swym-add-to-wishlist-view-product');
      if ($swymBtn.length) {
        $swymBtn.attr('data-variant-id', variantId);
      }
    }
  });
})();
//***************** Update Variant IDs on AddToCart Buttons End *******************//